<template>
  <div class="main-layouts">
    <Row type="flex" class="breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem to="/">
          <Icon type="ios-home-outline"></Icon>
          {{ $t('global.text4') }}
        </BreadcrumbItem>
        <BreadcrumbItem
          v-if="$route.name === 'announcement.show'"
          to="/announcements/list"
        >
          {{ $t('announcement.name') }}
        </BreadcrumbItem>
        <BreadcrumbItem
          v-if="$route.name === 'policies.show'"
          to="/policies/list"
        >
          {{ $t('policies.list') }}
        </BreadcrumbItem>
        <BreadcrumbItem v-if="!$route.query.form_id">
          {{
            $route.name !== 'approver'
              ? $t($route.name)
              : $t(`approval.${$route.query.type}`)
          }}
        </BreadcrumbItem>
        <BreadcrumbItem v-else>
          {{ $t('approval.report') }}
        </BreadcrumbItem>
      </Breadcrumb>
    </Row>
    <div class="main-container">
      <Row type="flex" v-if="!$route.query.form_id" class="main-head">
        {{
          $route.name !== 'approver'
            ? $t(`${$route.name}1`)
            : $t(`approval.${$route.query.type}`)
        }}
      </Row>
      <Row type="flex" v-else class="main-head">
        {{ $t('approval.report') }}
      </Row>
      <router-view v-if="$route.path === '/calendar/leave'"></router-view>
      <Row class="main-row" type="flex" v-else>
        <div class="main-left">
          <router-view></router-view>
        </div>
        <div class="main-right">
          <Row type="flex" justify="center">
            <div class="slider_phone_bg">
              <Row type="flex" justify="center">
                <div class="qr-code-container">
                  <img
                    class="qr_code"
                    src="@/assets/img/qr_code.png"
                    alt="qr_code"
                  />
                  <p class="down">{{ $t('global.text2') }}</p>
                </div>
                <div class="qr-code-text">
                  {{ $t('global.text') }}
                  <br />
                  <p
                    :class="{
                      'qr-code-text-id': $i18n.locale === 'id',
                      'qr-code-text-en': $i18n.locale === 'en'
                    }"
                  >
                    {{ $t('global.text1') }}
                  </p>
                </div>
              </Row>
            </div>
          </Row>
        </div>
      </Row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
.main-layouts {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.breadcrumb {
  background: #fff;
  padding: 12px 40px;
  margin-bottom: 15px;

  span {
    font-size: 14px;
    font-weight: 400;
    color: #9099a6;
    line-height: 16px;
    margin: 0 5px;
  }

  .link:hover {
    opacity: 0.49;
    cursor: pointer;
  }

  .active {
    color: #1f2329;
  }
}

.main-head {
  font-size: 24px;
  font-weight: 500;
  color: #646a73;
  line-height: 32px;
  margin-bottom: 15px;
}

.main-container {
  flex: 1;
  margin: 16px 40px;
  display: flex;
  flex-direction: column;

  .main-row {
    flex: 1;
  }

  .main-left {
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.06);
    border-radius: 6px;
    min-height: 448px;
    padding: 0 24px;
    width: calc(100% - 260px);
  }

  .main-right {
    margin-left: 40px;

    .slider_phone_bg {
      height: 448px;
      width: 210px;
      background: url('../../assets/img/slider_bg_phone.png') no-repeat;
    }

    .qr-code-container {
      margin-top: 70px;
      width: 138px;
      padding: 18px 12px;
      background: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(6, 17, 26, 0.08);
      border-radius: 6px;
    }

    .qr-code-text {
      margin-top: 15px;
      font-size: 16px;
      width: 120px;
      font-weight: 600;
      color: #ffffff;
      line-height: 1;
    }

    .qr_code {
      width: 100px;
    }

    .down {
      color: #1f2329;
      line-height: 1;
    }
  }
}

.qr-code-text-en {
  width: 136px;
  padding-left: 14px;
}

.qr-code-text-id {
  width: 148px;
}
</style>
